export default "__VITE_PUBLIC_ASSET__f6f67934__"